<template>
	<div class="container-fluid conteudo">
		<tabela-template
			:dados-tabela="anexos"
			:colunas-tabela="colunasTabela"
			:colunas-filtro="colunasFiltro"
			label-item="Veículos"
			:coluna-descricao="colunaDescricao"
			exibe-excluir
			exibe-editar
			:exibe-busca="false"
			@click-editar="clickEditar"
			@click-excluir="clickExcluir"
		/>
		<div>
			<button class="btn btn-info ml-5" @click.prevent="abrirModal">
				<i class="fa fa-plus" aria-hidden="true"></i> Adicionar Anexo
			</button>
		</div>
		<modal ref="modal">
			<div>
				<button type="button" class="close">
					<span aria-hidden="true" @click="fecharModal">&times;</span>
				</button>

				<h4 class="modal-title">{{ 'anexo' }}</h4>
				<hr class="mb-5" />
			</div>
			<div>
				<form-template :inputs="inputsFormated" :form="form">
					<template v-slot:input-anexo>
						<div class="col-xs-12 col-md-6 form-group">
							<label>{{ _traducao('global', 'arquivo') }}</label>
							<div class="d-flex">
								<input class="form-control" type="text" disabled v-model="form.nome" />
								<label for="anexo_input" class="btn btn-info ml-5">{{ _traducao('global', 'selecione') }}</label>
							</div>
						</div>
					</template>
				</form-template>
				<div class="row button-margin">
					<div class="col-xs-12">
						<button for="anexo_input" class="btn btn-success pull-right" @click.prevent="adicionar">
							<i class="fa fa-plus" aria-hidden="true"></i> Adicionar Anexo
						</button>
					</div>
				</div>
			</div>
		</modal>
		<flUploadFile
			class="d-none"
			ref="anexos"
			id-input="input"
			:unico="true"
			@upload-file="(files) => uploadFiles(files)"
			@enviando="loadArquivo(true)"
			@enviado="loadArquivo(false)"
			:url="urlEnvio"
			ext="jpg|jpeg|png|pdf|doc|docx|xls|xlsx"
		>
		</flUploadFile>
	</div>
</template>

<script>
export default {
	props: {
		anexos: {
			type: [Array, Object],
			required: true
		},
		inputs: {
			type: Array,
			default: () => []
		},
		colunasTabela: {
			type: Array,
			default: () => [{nome: this._traducao('global', 'nome'), campo: 'nome'}]
		}
	},
	data() {
		return {
			urlEnvio: this.getURL_WS('/Utilitarios/recebe_arquivo'),
			colunasFiltro: [],
			colunaDescricao: 'descricao',
			carregando: false,
			form: {
				nome: '',
				nomeTemp: ''
			}
		}
	},
	computed: {
		inputsFormated() {
			return [...this.inputs, {nome: 'anexo'}]
		}
	},
	watch: {
		'inputs.length': (novoValor, antigoValor) => {
			if (novoValor !== antigoValor) {
				this.inputs.forEach((input) => {
					this.$set(this.form, input.nome, '')
				})
			}
		}
	},
	mounted() {
		this.inputs.forEach((input) => {
			this.$set(this.form, input.nome, '')
		})
	},

	methods: {
		adicionar() {
			this.anexos.push({
				id: 0,
				...this.form
			})
			this.fecharModal()
		},
		fecharModal() {
			this.$refs.modal.modalHide()
		},
		abrirModal() {
			this.$refs.modal.modalShow(60)
		},
		loadArquivo(inicio) {
			if (inicio) {
				window.bus.$emit('load-in', {text: this._traducao('global', 'enviando')})
			} else {
				window.bus.$emit('load-out')
			}
		},
		uploadFiles(arquivos) {
			this.form.nome = arquivos[0].nome
			this.form.caminho = arquivos[0].nomeTemp
			this.form.nomeTemp = arquivos[0].nomeTemp
		},

		clickEditar(itemTabela) {
			this.abrirModal()
			this.form = itemTabela
		},

		clickExcluir(itemTabela) {
			window.bus.$emit('load-in', {text: this._traducao('global', 'excluindo')})
			this._httpGet('/Veiculo/salvar' + itemTabela.id, (response) => {
				window.bus.$emit('load-out')
				if (response._request && response._status) {
					window.bus.$emit('exibir-notificacao', {
						text: this._traducao('global', 'veiculoExcluidoComSucesso'),
						type: 'success'
					})
				} else {
					window.bus.$emit('exibir-notificacao', {type: 'danger', text: retorno.mensagem})
				}
			})
		}
	}
}
</script>